import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

// const badgeVariants = cva(
//   "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
//   {
//     variants: {
//       variant: {
//         default:
//           "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
//         secondary:
//           // "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
//           "border-transparent bg-grey-lighterer text-muted-foreground hover:bg-muted/80",
//         destructive:
//           "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
//         outline: "text-foreground",
//         success: "border-transparent bg-green-700 text-background hover:bg-green-800",
//         warning: "border-transparent bg-yellow-700 text-background hover:bg-yellow-800",
//         error: "border-transparent bg-red-600 text-background hover:bg-red-700",
//         info: "border-transparent bg-blue-500 text-background hover:bg-blue-600",
//         muted: "border-transparent bg-gray-500 text-background hover:bg-gray-600",
//         light: "border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200",
//         dark: "border-transparent bg-gray-800 text-background hover:bg-gray-900",
//         accent: "border-transparent bg-accent text-accent-foreground hover:bg-accent/80",
//       },
//     },
//     defaultVariants: {
//       variant: "default",
//     },
//   }
// )
const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
        secondary:
          "bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive:
          "bg-destructive text-white focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40 [a&]:hover:bg-destructive/90",
        outline:
          "border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        ghost: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        link: "text-primary underline-offset-4 [a&]:hover:underline",
        success: "bg-success text-success-foreground focus-visible:ring-success/20 dark:focus-visible:ring-success/40 [a&]:hover:bg-success/90",
        warning: "bg-warning text-warning-foreground focus-visible:ring-warning/20 dark:focus-visible:ring-warning/40 [a&]:hover:bg-warning/90",
        error: "bg-error text-error-foreground focus-visible:ring-error/20 dark:focus-visible:ring-error/40 [a&]:hover:bg-error/90",
        info: "bg-info text-info-foreground focus-visible:ring-info/20 dark:focus-visible:ring-info/40 [a&]:hover:bg-info/90"
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(badgeVariants({ variant }), className)}
        {...props}
      />
    )
  }
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }
